function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 35 35",
  fill: "none"
}, props), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.666 11.666H0v11.667h11.666V35h11.667V23.333H35V11.666H23.333V0H11.666v11.666zm2.47-9.196v11.666H2.47v6.727h11.666V32.53h6.727V20.863H32.53v-6.727H20.863V2.47h-6.727z",
  fill: "#354147"
})));